import styled, { css } from 'styled-components'
import type { SubsectionProps } from './types'

export const Container = styled.div`
  line-height: var(--font-line-height-400);

  & + & {
    margin-top: var(--space-1000);
  }
`

export const Title = styled.div<{
  $borderless: NonNullable<SubsectionProps['borderless']>
  $noMargin: NonNullable<SubsectionProps['noMargin']>
}>`
  &::after {
    content: '';
    display: block;
    height: 1px;
    margin-top: var(--space-200);
    margin-bottom: var(--space-400);
    background: var(--border-secondary);

    ${({ $noMargin }) =>
      $noMargin &&
      css`
        margin-bottom: 0;
      `};
  }

  ${({ $borderless }) =>
    $borderless &&
    css`
      margin-bottom: var(--space-400);

      &::after {
        content: none;
      }
    `};
`

export const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`

export const Heading = styled.div`
  flex: 1;
`

export const RightContent = styled.div`
  margin-left: var(--space-400);
`
